export default {
  computed: {
    currentRealAccomodationIndex() {
      if (typeof this.$route.query.no === 'undefined') {
        return -1;
      }
      let no = parseInt(this.$route.query.no, 10);

      if (isNaN(no)) {
        return -1;
      }

      const max = this.$store.state.cart.accomodations.length;

      no = Math.min(no, max);
      no = Math.max(no, -1);

      return no;
    },
    accomodationIndex() {
      return Math.max(this.currentRealAccomodationIndex, 0);
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/accomodationIndex.js